module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('gheader', {
    attrs: {
      "type": "home"
    }
  }), _vm._v(" "), _c('glogo'), _vm._v(" "), _c('grednav', {
    attrs: {
      "type": "home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row-agreement"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    attrs: {
      "id": "agreement"
    }
  }, [_c('h2', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("供应商操作手册")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('h4', [_vm._v("一、供应商须知")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("尊敬的供应商：")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("你好！")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("目前" + _vm._s(_vm.companyName) + "采购门户已经上线了网上招标采购系统，未来我们会把更多的采购信息都发布到系统中，期待您注册网上招采平台和我们长期合作。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("为了帮助您更好的了解和掌握此系统，我们编写的以下操作手册，希望能够帮到您。以后如果在使用过程中遇到问题，一定要记得及时联系我们哦。")]), _vm._v(" "), _c('h4', [_vm._v("二、供应商申请流程")]), _vm._v(" "), _c('h5', [_vm._v("1.网上招采地址")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("请在浏览器中输入地址https://yc.yonyoucloud.com/" + _vm._s(_vm.context) + " 登陆" + _vm._s(_vm.companyName) + "采购门户。")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h5', [_vm._v("2.供应商注册")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("希望参加" + _vm._s(_vm.companyName) + "采购招标的供应商需要在网上申请成为" + _vm._s(_vm.companyName) + "的供应商。")]), _vm._v(" "), _c('h6', [_vm._v("2.1 开始注册")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("点击“供应商注册”按钮开始注册。")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h6', [_vm._v("2.2 确认相关条款")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("同意并继续后开始填写相关资料")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h6', [_vm._v("2.3 填写账号信息")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("手机号：需要用手机号进行注册（一个手机号只能注册一个账号）")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("账号：即登录采购门户进行报名，投标等操作的账号（账号必须是唯一的无法重复）")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("密码：账户的密码")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("企业名称：请确认是公司全称，注册后无法修改。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("相关信息填写完整后点击“下一步，完善供应商信息”系统会提示“您的账号已经注册成功”")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h6', [_vm._v("2.4 完善供应商信息")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("完善供应商注册信息有两种方式，一种是继续完善供应商资料，另一种时登录账号继续完善相关资料。（两种方式选择一种即可）")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("供应商名称：由上一步代入")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("管理组织：即确定您提交的资料由哪一家公司审核。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("供应商资质信息：请选择是上传三证还是五证，并需要填写相关证件账号。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("供应品类：即您要申请的供货类别（请如实填写）")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("2.4.1 继续完善资料")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("相关资料填写完成后点击“提交采购商审核即可”。")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("2.4.2 登录账号完善资料。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("2.4.2.1 返回采购门户，点击按钮“立即登录”。输入“账号”“密码”后登录。")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("2.4.2.2 登录后点击“供应商申请”按钮填写供应商相关资料。")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("\n            同意相关条款后，直接到供应商资料填写页面，填写完相关资料后，提交采购商审核即可\n          ")]), _vm._v(" "), _c('h5', [_vm._v("三、查看供应商审核是否通过")]), _vm._v(" "), _c('h6', [_vm._v("3.1 账号登录")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("登录供应商账号，登录后点击进入工作台。")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h6', [_vm._v("3.2 查看供应商申请界面")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('h6', [_vm._v("3.3 查看审核是否通过")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("待审核状态可以查看相关供应商资料，申请被驳回后，可以修改相关资料重新提交，申请通过后可以参加" + _vm._s(_vm.companyName) + "相关企业的采购招标。")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('h4', [_vm._v("三、供应商招标")]), _vm._v(" "), _c('h5', [_vm._v("1.供应商报名")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("供应商报名分两种情况，一种是邀请报名，一种是直接报名。")]), _vm._v(" "), _c('h6', [_vm._v("1.1 邀请报名")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("直接登录账号即可，登录账户，进入工作台，投标管理，在报名中查看“待报名”的数量，点击“报名”按钮，填写相关资料报名即可。")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h6', [_vm._v("1.2 直接报名")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("在" + _vm._s(_vm.companyName) + "招采门户，查询招标信息，点击相关招标信息，点击我要报名，然后登录后，点击报名，填写相关资料后，点击“报名”即可")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('h5', [_vm._v("2.供应商招标")]), _vm._v(" "), _c('h6', [_vm._v("2.1 供应商投标")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("\n            登录账号如果在招标管理，在待投标里可以看到可以投标的数量，上传附件，输入报价，点击“保存”“投标”按钮即可。采购商如果对报价不满意，可以发起谈判，然后供应商可以在“待投标”进行报价。")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('h5', [_vm._v("3.中标通知")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("中标后供应商账号和招标门户都会收到中标通知。")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "source"
    }
  }, [_c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_1.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_2.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual4.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual5.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_3.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_9.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_5.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual10.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual11.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual12.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_6.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual14.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_7.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual16.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual17.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual18.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual19.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual20.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_8.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6589fefb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/manual/manual.vue
// module id = 259
// module chunks = 16